var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initProductCard = /* @__PURE__ */ __name(($el, $refs, productHandle, productId, variantId, default_select_selling_plan = false) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B;
  const random_id = utils.shortUUID();
  const settings = utils.JSONParse($el.getAttribute("data-settings"));
  const option_blocks = [
    ...((_a = $el.querySelectorAll("[data-options-block]")) == null ? void 0 : _a.length) ? $el.querySelectorAll("[data-options-block]") : (_d = (_c = (_b = $el.querySelector("template")) == null ? void 0 : _b.content) == null ? void 0 : _c.querySelectorAll("[data-options-block]")) != null ? _d : []
  ].map(
    (block) => utils.JSONParse(block.getAttribute("data-options-block"))
  );
  let product = _products[productHandle];
  if (!product) {
    _product.getProductData(productHandle, productId).then((res) => {
      updateProductState(res);
    });
  }
  product != null ? product : product = _products[productHandle];
  if (settings == null ? void 0 : settings.default_variant_metafield) {
    const [namespace, key] = settings.default_variant_metafield.trim().split(".");
    const variant = (_f = (_e = product == null ? void 0 : product.metafields) == null ? void 0 : _e[namespace]) == null ? void 0 : _f[key];
    variantId = (_g = variant == null ? void 0 : variant.id) != null ? _g : product == null ? void 0 : product.selected_variant_id;
  }
  const selected_variant = ((_h = product == null ? void 0 : product.variants) == null ? void 0 : _h.find((v) => v.id === variantId)) || ((_i = product == null ? void 0 : product.variants) == null ? void 0 : _i.find((v) => v.id === product.selected_variant_id)) || ((_j = product == null ? void 0 : product.variants) == null ? void 0 : _j.find(
    (v) => {
      var _a2;
      return v.id && ((_a2 = product.options_with_values) == null ? void 0 : _a2.every((option, i) => {
        var _a3;
        return _product.lastOptions[(_a3 = option == null ? void 0 : option.name) == null ? void 0 : _a3.toLowerCase()] === v.options[i];
      }));
    }
  )) || ((_k = product == null ? void 0 : product.variants) == null ? void 0 : _k.find(
    (v) => {
      var _a2;
      return v.id && ((_a2 = product.options_with_values.slice(0, product.options_with_values.length - 1)) == null ? void 0 : _a2.every((option, i) => {
        var _a3;
        return _product.lastOptions[(_a3 = option == null ? void 0 : option.name) == null ? void 0 : _a3.toLowerCase()] === v.options[i];
      }));
    }
  )) || ((_l = product == null ? void 0 : product.variants) == null ? void 0 : _l.find(
    (v) => {
      var _a2;
      return v.id && ((_a2 = product.options_with_values.slice(0, product.options_with_values.length - 2)) == null ? void 0 : _a2.every((option, i) => {
        var _a3;
        return _product.lastOptions[(_a3 = option == null ? void 0 : option.name) == null ? void 0 : _a3.toLowerCase()] === v.options[i];
      }));
    }
  )) || ((_m = product == null ? void 0 : product.variants) == null ? void 0 : _m.find(
    (v) => {
      var _a2;
      return v.id && ((_a2 = product.options_with_values) == null ? void 0 : _a2.some((option, i) => {
        var _a3;
        return _product.lastOptions[(_a3 = option == null ? void 0 : option.name) == null ? void 0 : _a3.toLowerCase()] === v.options[i];
      }));
    }
  )) || ((_n = product == null ? void 0 : product.variants) == null ? void 0 : _n.find((v) => v.id === product.selected_or_first_available_variant_id)) || ((_o = product == null ? void 0 : product.variants) == null ? void 0 : _o[0]);
  const selling_plan_allocations = selected_variant == null ? void 0 : selected_variant.selling_plan_allocations;
  const selected_selling_plan = default_select_selling_plan ? (_p = selling_plan_allocations == null ? void 0 : selling_plan_allocations[0]) == null ? void 0 : _p.selling_plan : null;
  const selling_plan_discount_wording = +((_r = (_q = selected_selling_plan == null ? void 0 : selected_selling_plan.price_adjustments) == null ? void 0 : _q[0]) == null ? void 0 : _r.value) ? ((_t = (_s = selected_selling_plan == null ? void 0 : selected_selling_plan.price_adjustments) == null ? void 0 : _s[0]) == null ? void 0 : _t.value_type) === "fixed_amount" ? `${utils.formatMoney((_v = (_u = selected_selling_plan == null ? void 0 : selected_selling_plan.price_adjustments) == null ? void 0 : _u[0]) == null ? void 0 : _v.value)} off` : ((_x = (_w = selected_selling_plan == null ? void 0 : selected_selling_plan.price_adjustments) == null ? void 0 : _w[0]) == null ? void 0 : _x.value_type) === "percentage" ? `Save ${(_z = (_y = selected_selling_plan == null ? void 0 : selected_selling_plan.price_adjustments) == null ? void 0 : _y[0]) == null ? void 0 : _z.value}%` : "" : "";
  const state = window.Alpine.reactive({
    product_handle: productHandle,
    random_id,
    hydrated: !!product,
    variant_changed: false,
    settings,
    product,
    selected_media_id: (_B = (_A = product == null ? void 0 : product.media) == null ? void 0 : _A[0]) == null ? void 0 : _B.id,
    properties: {},
    selected_variant,
    selling_plan_allocations,
    selected_selling_plan,
    selling_plan_discount_wording,
    isAdding: false,
    selected_options: selected_variant == null ? void 0 : selected_variant.options,
    quantity: 1,
    sibling_handle: ""
  });
  const handleAddToCart = /* @__PURE__ */ __name(async (e) => {
    var _a2, _b2;
    e.preventDefault();
    e.stopPropagation();
    const bundleMapping = utils.getBundleMapping();
    const bundleHandle = state.product_handle;
    if (bundleMapping[bundleHandle]) {
      state.isAdding = true;
      await addBundleItemsToCart(bundleMapping[bundleHandle]);
      state.isAdding = false;
      _stores.modal.setId("modal--cart-drawer");
      _stores.productDrawer.show = false;
      _stores.quickView.show = false;
      return;
    }
    const properties = {};
    (_a2 = Object.entries(utils.serializeForm($el.querySelector("form")))) == null ? void 0 : _a2.forEach(([key, value]) => {
      if (key.includes("properties[") && value) {
        properties[key.replace(/^properties\[(.*)]$/gi, "$1")] = value;
      }
    });
    state.isAdding = true;
    const data = await _cart.add({
      items: [
        {
          id: state.selected_variant.id,
          quantity: state.quantity,
          selling_plan: (_b2 = state.selected_selling_plan) == null ? void 0 : _b2.id,
          properties: {
            ...properties,
            ...state.properties
          }
        }
      ]
    });
    state.isAdding = false;
    _stores.modal.setId("modal--cart-drawer");
    _stores.productDrawer.show = false;
    _stores.quickView.show = false;
  }, "handleAddToCart");
  async function addBundleItemsToCart(bundle) {
    var _a2, _b2, _c2, _d2, _e2;
    const dynamicBoxID = (_a2 = window.theme_settings) == null ? void 0 : _a2.data__product__skio_dynamic_box_id;
    const items = bundle["products"];
    let bundleIndex = 0;
    let maxIndex = -1;
    const cart = await _cart.get();
    (_b2 = cart == null ? void 0 : cart.items) == null ? void 0 : _b2.forEach((item) => {
      const props = item.properties;
      if (!props) return;
      if (String(props["_dynamicBoxId"]) !== String(dynamicBoxID)) return;
      if (props["_dynamicBoxIndex"] === void 0) return;
      const index = parseInt(String(props["_dynamicBoxIndex"]), 10);
      if (Number.isNaN(index)) return;
      maxIndex = Math.max(maxIndex, index);
      bundleIndex = Math.max(bundleIndex, index + 1);
    });
    if (maxIndex >= 0) {
      const wantedVariants = items.map((item) => Number(item.external_variant_id)).sort((a, b) => a - b).join(",");
      const groups = /* @__PURE__ */ new Map();
      ((_c2 = cart == null ? void 0 : cart.items) != null ? _c2 : []).forEach((line) => {
        var _a3, _b3, _c3, _d3;
        const p = line == null ? void 0 : line.properties;
        if (!p) return;
        if (String(p["_dynamicBoxId"]) !== String(dynamicBoxID)) return;
        if (p["_dynamicBoxIndex"] === void 0) return;
        const idx = parseInt(String(p["_dynamicBoxIndex"]), 10);
        if (Number.isNaN(idx)) return;
        const group = (_a3 = groups.get(idx)) != null ? _a3 : { variants: [], plan: "" };
        group.variants.push(Number((_b3 = line.variant_id) != null ? _b3 : line.id));
        const planId = ((_d3 = (_c3 = line == null ? void 0 : line.selling_plan_allocation) == null ? void 0 : _c3.selling_plan) == null ? void 0 : _d3.id) != null ? String(line.selling_plan_allocation.selling_plan.id) : "";
        group.plan = group.plan || planId;
        groups.set(idx, group);
      });
      for (const [idx, g] of groups.entries()) {
        const existingVariants = ((_d2 = g.variants) != null ? _d2 : []).sort((a, b) => a - b).join(",");
        const existingPlan = String((_e2 = g.plan) != null ? _e2 : "");
        const same = existingVariants === wantedVariants && !existingPlan;
        if (same) {
          bundleIndex = idx;
          break;
        }
      }
    }
    /* items.forEach((item) => {
      item["properties"] = {
        _dynamicBoxId: dynamicBoxID,
        _dynamicBoxIndex: bundleIndex,
        Bundle: state.product.title
      };
    }); */
    const response = await _cart.add({
      items: items.map((item) => ({
        id: Number(item.external_variant_id),
        quantity: state.quantity,
        selling_plan: (item == null ? void 0 : item.selling_plan) || null,
        properties: item.properties
      }))
    });
    const event = new CustomEvent(`skio::added-to-cart`, {
      bubbles: true,
      composed: true,
      detail: {
        response
      }
    });
    document.dispatchEvent(event);
  }
  __name(addBundleItemsToCart, "addBundleItemsToCart");
  const handleBackInStockNotification = /* @__PURE__ */ __name(async (e) => {
    var _a2;
    if ((_a2 = state == null ? void 0 : state.selected_variant) == null ? void 0 : _a2.available) return;
    e.preventDefault();
    e.stopPropagation();
    _stores.backInStockNotification.show = true;
    _stores.backInStockNotification.product = state.product;
    _stores.backInStockNotification.selected_variant = state.selected_variant;
  }, "handleBackInStockNotification");
  const setSelectedVariant = /* @__PURE__ */ __name((id) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2, _n2, _o2, _p2, _q2;
    state.selected_variant = (_a2 = state.product.variants) == null ? void 0 : _a2.find((variant) => variant.id === id);
    state.selected_options = state.selected_variant.options;
    state.variant_changed = true;
    if (state.selected_selling_plan && !((_c2 = (_b2 = state.selected_variant) == null ? void 0 : _b2.selling_plan_allocations) == null ? void 0 : _c2.some(
      (plan) => {
        var _a3, _b3;
        return ((_a3 = plan == null ? void 0 : plan.selling_plan) == null ? void 0 : _a3.id) === ((_b3 = state.selected_selling_plan) == null ? void 0 : _b3.id);
      }
    ))) {
      state.selected_selling_plan = (_g2 = (_f2 = (_e2 = (_d2 = state.selected_variant) == null ? void 0 : _d2.selling_plan_allocations) == null ? void 0 : _e2[0]) == null ? void 0 : _f2.selling_plan) != null ? _g2 : null;
    }
    if (state.product.requires_selling_plan && !state.selected_selling_plan) {
      state.selected_selling_plan = (_n2 = (_j2 = (_i2 = (_h2 = state.selected_variant) == null ? void 0 : _h2.selling_plan_allocations) == null ? void 0 : _i2[0]) == null ? void 0 : _j2.selling_plan) != null ? _n2 : (_m2 = (_l2 = (_k2 = state.product.selling_plan_groups) == null ? void 0 : _k2[0]) == null ? void 0 : _l2.selling_plans) == null ? void 0 : _m2[0];
    }
    _product.lastOptions = {
      ...(_o2 = _product.lastOptions) != null ? _o2 : {},
      ...(_q2 = (_p2 = state.product.options_with_values) == null ? void 0 : _p2.reduce((acc, option, index) => {
        var _a3;
        acc[(_a3 = option == null ? void 0 : option.name) == null ? void 0 : _a3.toLowerCase()] = state.selected_options[index];
        return acc;
      }, {})) != null ? _q2 : {}
    };
  }, "setSelectedVariant");
  const setProductOption = /* @__PURE__ */ __name(({ index, value }) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2, _n2;
    const options = [...state.selected_options];
    options[index] = value;
    setSelectedVariant(
      (_n2 = (_j2 = (_f2 = (_b2 = (_a2 = state.product.variants) == null ? void 0 : _a2.find((variant) => variant.options.every((option, i) => options[i] === option))) == null ? void 0 : _b2.id) != null ? _f2 : (_e2 = (_d2 = (_c2 = state.product) == null ? void 0 : _c2.variants) == null ? void 0 : _d2.find((variant) => variant.options[index] === value)) == null ? void 0 : _e2.id) != null ? _j2 : (_i2 = (_h2 = (_g2 = state.product) == null ? void 0 : _g2.variants) == null ? void 0 : _h2.find(({ available }) => available)) == null ? void 0 : _i2.id) != null ? _n2 : (_m2 = (_l2 = (_k2 = state.product) == null ? void 0 : _k2.variants) == null ? void 0 : _l2[0]) == null ? void 0 : _m2.id
    );
  }, "setProductOption");
  const setSellingPlan = /* @__PURE__ */ __name((selling_plan_id) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2;
    state.selected_selling_plan = (_a2 = state.selling_plan_allocations.find(
      (allocation) => allocation.selling_plan.id === selling_plan_id
    )) == null ? void 0 : _a2.selling_plan;
    const selling_plan = (_c2 = state.selected_selling_plan) != null ? _c2 : (_b2 = selling_plan_allocations == null ? void 0 : selling_plan_allocations[0]) == null ? void 0 : _b2.selling_plan;
    state.selling_plan_discount_wording = ((_e2 = (_d2 = selling_plan == null ? void 0 : selling_plan.price_adjustments) == null ? void 0 : _d2[0]) == null ? void 0 : _e2.value_type) === "fixed_amount" ? `${utils.formatMoney((_g2 = (_f2 = selling_plan == null ? void 0 : selling_plan.price_adjustments) == null ? void 0 : _f2[0]) == null ? void 0 : _g2.value)} off` : ((_i2 = (_h2 = selling_plan == null ? void 0 : selling_plan.price_adjustments) == null ? void 0 : _h2[0]) == null ? void 0 : _i2.value_type) === "percentage" ? `Save ${(_k2 = (_j2 = selling_plan == null ? void 0 : selling_plan.price_adjustments) == null ? void 0 : _j2[0]) == null ? void 0 : _k2.value}%` : "";
  }, "setSellingPlan");
  const getDynamicText = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicText(content, state);
  }, "getDynamicText");
  const getDynamicValue = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicValue(content, state);
  }, "getDynamicValue");
  const getContentLabels = /* @__PURE__ */ __name((key) => {
    const value = key.split(".").reduce((acc, selector) => {
      if (!selector || acc === void 0 || acc === null) return void 0;
      if (typeof acc === "object" && selector in acc) {
        return acc[selector];
      }
      return void 0;
    }, state);
    if (Array.isArray(value)) {
      return value.filter(Boolean);
    }
    if (value && typeof value === "object") {
      return [value];
    }
    if (value !== void 0 && value !== null) {
      return [value];
    }
    return [];
  }, "getContentLabels");
  const getDiscountLabel = /* @__PURE__ */ __name((type) => {
    var _a2, _b2, _c2, _d2, _e2;
    const price = (_b2 = (_a2 = state.selected_variant) == null ? void 0 : _a2.price) != null ? _b2 : 0;
    const compare_at_price = (_d2 = (_c2 = state.selected_variant) == null ? void 0 : _c2.compare_at_price) != null ? _d2 : 0;
    if (compare_at_price <= price) {
      return "";
    }
    switch (type) {
      case "sale": {
        return "Sale";
      }
      case "percentage": {
        return `${Math.round((compare_at_price - price) * 100 / compare_at_price)}% off`;
      }
      case "value": {
        return `Save ${utils.formatMoney(
          compare_at_price - price,
          (_e2 = window == null ? void 0 : window.money_format) == null ? void 0 : _e2.replace(/\{(\s*)amount(\s*)}/gi, "{$1amount_no_decimals$2}")
        )}`;
      }
      default: {
        return "";
      }
    }
  }, "getDiscountLabel");
  const getVariantSwatches = /* @__PURE__ */ __name((primary_source, fallback_source, variant) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2;
    const cssVariables = [];
    switch (primary_source) {
      case "title": {
        cssVariables.push(`--primary-swatch: var(--swatch-${utils.handlelize(variant.title)})`);
        break;
      }
      case "image": {
        const [src, version] = (_c2 = (_b2 = (_a2 = variant == null ? void 0 : variant.featured_media) == null ? void 0 : _a2.preview_image) == null ? void 0 : _b2.src.split("?")) != null ? _c2 : [];
        if (!src) break;
        cssVariables.push(`--primary-swatch: url(${src}?width=60&height=60&${version}) center center/cover no-repeat`);
        break;
      }
      case "metafield": {
        const color_swatch = variant.metafields.smart.color_swatch;
        if (typeof color_swatch === "string") {
          cssVariables.push(`--primary-swatch: ${color_swatch}`);
          break;
        }
        if (color_swatch) {
          const [src, version] = (_e2 = (_d2 = color_swatch == null ? void 0 : color_swatch.preview_image) == null ? void 0 : _d2.src.split("?")) != null ? _e2 : [];
          if (!src) break;
          cssVariables.push(`--primary-swatch: url(${src}?width=60&height=60&${version}) center center/cover no-repeat`);
          cssVariables.push(`--primary-swatch: ${color_swatch}`);
        }
        break;
      }
    }
    switch (fallback_source) {
      case "title": {
        cssVariables.push(`--fallback-swatch: var(--swatch-${utils.handlelize(variant.title)})`);
        break;
      }
      case "image": {
        const [src, version] = (_h2 = (_g2 = (_f2 = variant == null ? void 0 : variant.featured_media) == null ? void 0 : _f2.preview_image) == null ? void 0 : _g2.src.split("?")) != null ? _h2 : [];
        if (!src) break;
        cssVariables.push(`--fallback-swatch: url(${src}?width=60&height=60&${version}) center center/cover no-repeat`);
        break;
      }
      case "metafield": {
        const color_swatch = variant.metafields.smart.color_swatch;
        if (typeof color_swatch === "string") {
          cssVariables.push(`--fallback-swatch: ${color_swatch}`);
          break;
        }
        if (color_swatch) {
          const [src, version] = (_j2 = (_i2 = color_swatch == null ? void 0 : color_swatch.preview_image) == null ? void 0 : _i2.src.split("?")) != null ? _j2 : [];
          if (!src) break;
          cssVariables.push(`--fallback-swatch: url(${src}?width=60&height=60&${version}) center center/cover no-repeat`);
          cssVariables.push(`--fallback-swatch: ${color_swatch}`);
        }
        break;
      }
    }
    return `${cssVariables == null ? void 0 : cssVariables.join(";")};background: var(--primary-swatch, var(--fallback-swatch, ${utils.handlelize(
      variant == null ? void 0 : variant.title
    )}))`;
  }, "getVariantSwatches");
  const getOptionIndex = /* @__PURE__ */ __name((blockId) => {
    var _a2, _b2, _c2, _d2, _e2;
    const optionBlocks = [];
    for (let i = 0; i < (((_b2 = (_a2 = state.product) == null ? void 0 : _a2.options) == null ? void 0 : _b2.length) || 0); i++) {
      const option = (_c2 = state.product) == null ? void 0 : _c2.options[i];
      const primaryBlock = option_blocks == null ? void 0 : option_blocks.find((block) => {
        var _a3, _b3;
        const alreadyUsed = optionBlocks.some((b) => b.id === block.block_id);
        if (alreadyUsed || !block.match_option_titles) return false;
        if (block.match_exact_word) {
          return (_a3 = block.match_option_titles) == null ? void 0 : _a3.split(",").includes(option);
        }
        return (_b3 = block.match_option_titles) == null ? void 0 : _b3.split(",").map((o) => o.toLowerCase().trim()).includes(option.toLowerCase().trim());
      });
      if (primaryBlock) {
        optionBlocks.push({ index: i, id: primaryBlock.block_id });
        continue;
      }
      const fallbackBlock = option_blocks == null ? void 0 : option_blocks.find(
        (block) => !optionBlocks.some((b) => b.id === block.block_id) && !block.match_option_titles
      );
      if (fallbackBlock) {
        optionBlocks.push({ index: i, id: fallbackBlock.block_id });
      }
    }
    return (_e2 = (_d2 = optionBlocks == null ? void 0 : optionBlocks.find((block) => block.id === blockId)) == null ? void 0 : _d2.index) != null ? _e2 : -1;
  }, "getOptionIndex");
  const getOptionSwatches = /* @__PURE__ */ __name((primary_source, fallback_source, value, index) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2, _n2, _o2, _p2;
    const variant = (_b2 = (_a2 = state == null ? void 0 : state.product) == null ? void 0 : _a2.variants) == null ? void 0 : _b2.find((variant2) => variant2.options[index] === value);
    const cssVariables = [];
    switch (primary_source) {
      case "title": {
        cssVariables.push(`--primary-swatch: var(--swatch-${utils.handlelize(value)})`);
        break;
      }
      case "image": {
        const [src, version] = (_f2 = (_e2 = (_d2 = (_c2 = variant == null ? void 0 : variant.featured_media) == null ? void 0 : _c2.preview_image) == null ? void 0 : _d2.src) == null ? void 0 : _e2.split("?")) != null ? _f2 : [];
        if (!src) break;
        cssVariables.push(`--primary-swatch: url(${src}?width=60&height=60&${version}) center center/cover no-repeat`);
        break;
      }
      case "metafield": {
        const color_swatch = variant.metafields.smart.color_swatch;
        if (typeof color_swatch === "string") {
          cssVariables.push(`--primary-swatch: ${color_swatch}`);
          break;
        }
        if (color_swatch) {
          const [src, version] = (_i2 = (_h2 = (_g2 = color_swatch == null ? void 0 : color_swatch.preview_image) == null ? void 0 : _g2.src) == null ? void 0 : _h2.split("?")) != null ? _i2 : [];
          if (!src) break;
          cssVariables.push(`--primary-swatch: url(${src}?width=60&height=60&${version}) center center/cover no-repeat`);
          cssVariables.push(`--primary-swatch: ${color_swatch}`);
        }
        break;
      }
    }
    switch (fallback_source) {
      case "title": {
        cssVariables.push(`--fallback-swatch: var(--swatch-${utils.handlelize(value)})`);
        break;
      }
      case "image": {
        const [src, version] = (_m2 = (_l2 = (_k2 = (_j2 = variant == null ? void 0 : variant.featured_media) == null ? void 0 : _j2.preview_image) == null ? void 0 : _k2.src) == null ? void 0 : _l2.split("?")) != null ? _m2 : [];
        if (!src) break;
        cssVariables.push(`--fallback-swatch: url(${src}?width=60&height=60&${version}) center center/cover no-repeat`);
        break;
      }
      case "metafield": {
        const color_swatch = variant.metafields.smart.color_swatch;
        if (typeof color_swatch === "string") {
          cssVariables.push(`--fallback-swatch: ${color_swatch}`);
          break;
        }
        if (color_swatch) {
          const [src, version] = (_p2 = (_o2 = (_n2 = color_swatch == null ? void 0 : color_swatch.preview_image) == null ? void 0 : _n2.src) == null ? void 0 : _o2.split("?")) != null ? _p2 : [];
          if (!src) break;
          cssVariables.push(`--fallback-swatch: url(${src}?width=60&height=60&${version}) center center/cover no-repeat`);
          cssVariables.push(`--fallback-swatch: ${color_swatch}`);
        }
        break;
      }
    }
    return `${cssVariables == null ? void 0 : cssVariables.join(";")};background: var(--primary-swatch, var(--fallback-swatch, ${utils.handlelize(value)}))`;
  }, "getOptionSwatches");
  const truncateChildren = /* @__PURE__ */ __name((element, container) => {
    var _a2, _b2;
    const children = [...container.children];
    if (((_a2 = children.at(-2)) == null ? void 0 : _a2.offsetLeft) + ((_b2 = children.at(-2)) == null ? void 0 : _b2.clientWidth) < container.clientWidth) {
      return children.length - 2;
    }
    return children.findIndex(
      (childElement) => childElement.offsetLeft + childElement.clientWidth + element.clientWidth + +getComputedStyle(container).gap.replace("px", "") + 15 > container.clientWidth
    ) - 1;
  }, "truncateChildren");
  const hasAvailableVariant = /* @__PURE__ */ __name((index, value) => {
    var _a2, _b2;
    return (_b2 = (_a2 = state == null ? void 0 : state.product) == null ? void 0 : _a2.variants) == null ? void 0 : _b2.some((variant) => {
      switch (index) {
        case 0: {
          return variant.options[index] === value && variant.available;
        }
        case 1: {
          return variant.options[0] === (state == null ? void 0 : state.selected_options[0]) && variant.options[index] === value && variant.available;
        }
        case 2: {
          return variant.options[0] === (state == null ? void 0 : state.selected_options[0]) && variant.options[1] === (state == null ? void 0 : state.selected_options[1]) && variant.options[index] === value && variant.available;
        }
      }
      return false;
    });
  }, "hasAvailableVariant");
  const updateProductState = /* @__PURE__ */ __name((product2) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2, _n2, _o2, _p2, _q2, _r2, _s2, _t2, _u2, _v2, _w2;
    if ((settings == null ? void 0 : settings.default_variant_metafield) && product2) {
      const [namespace, key] = settings.default_variant_metafield.trim().split(".");
      const variant = (_b2 = (_a2 = product2 == null ? void 0 : product2.metafields) == null ? void 0 : _a2[namespace]) == null ? void 0 : _b2[key];
      product2.selected_variant_id = (_c2 = variant == null ? void 0 : variant.id) != null ? _c2 : product2 == null ? void 0 : product2.selected_variant_id;
    }
    const selected_variant2 = ((_d2 = product2 == null ? void 0 : product2.variants) == null ? void 0 : _d2.find((v) => v.id === product2.selected_variant_id)) || ((_e2 = product2 == null ? void 0 : product2.variants) == null ? void 0 : _e2.find(
      (v) => {
        var _a3;
        return v.id && ((_a3 = product2.options_with_values) == null ? void 0 : _a3.every((option, i) => {
          var _a4;
          return _product.lastOptions[(_a4 = option == null ? void 0 : option.name) == null ? void 0 : _a4.toLowerCase()] === v.options[i];
        }));
      }
    )) || ((_f2 = product2 == null ? void 0 : product2.variants) == null ? void 0 : _f2.find(
      (v) => {
        var _a3;
        return v.id && ((_a3 = product2.options_with_values.slice(0, product2.options_with_values.length - 1)) == null ? void 0 : _a3.every((option, i) => {
          var _a4;
          return _product.lastOptions[(_a4 = option == null ? void 0 : option.name) == null ? void 0 : _a4.toLowerCase()] === v.options[i];
        }));
      }
    )) || ((_g2 = product2 == null ? void 0 : product2.variants) == null ? void 0 : _g2.find(
      (v) => {
        var _a3;
        return v.id && ((_a3 = product2.options_with_values.slice(0, product2.options_with_values.length - 2)) == null ? void 0 : _a3.every((option, i) => {
          var _a4;
          return _product.lastOptions[(_a4 = option == null ? void 0 : option.name) == null ? void 0 : _a4.toLowerCase()] === v.options[i];
        }));
      }
    )) || ((_h2 = product2 == null ? void 0 : product2.variants) == null ? void 0 : _h2.find(
      (v) => {
        var _a3;
        return v.id && ((_a3 = product2.options_with_values) == null ? void 0 : _a3.some((option, i) => {
          var _a4;
          return _product.lastOptions[(_a4 = option == null ? void 0 : option.name) == null ? void 0 : _a4.toLowerCase()] === v.options[i];
        }));
      }
    )) || ((_i2 = product2 == null ? void 0 : product2.variants) == null ? void 0 : _i2.find((v) => v.id === product2.selected_or_first_available_variant_id)) || ((_j2 = product2 == null ? void 0 : product2.variants) == null ? void 0 : _j2[0]);
    const selling_plan_allocations2 = selected_variant2 == null ? void 0 : selected_variant2.selling_plan_allocations;
    const selected_selling_plan2 = default_select_selling_plan ? (_k2 = selling_plan_allocations2 == null ? void 0 : selling_plan_allocations2[0]) == null ? void 0 : _k2.selling_plan : null;
    const selling_plan_discount_wording2 = +((_m2 = (_l2 = selected_selling_plan2 == null ? void 0 : selected_selling_plan2.price_adjustments) == null ? void 0 : _l2[0]) == null ? void 0 : _m2.value) ? ((_o2 = (_n2 = selected_selling_plan2 == null ? void 0 : selected_selling_plan2.price_adjustments) == null ? void 0 : _n2[0]) == null ? void 0 : _o2.value_type) === "fixed_amount" ? `${utils.formatMoney((_q2 = (_p2 = selected_selling_plan2 == null ? void 0 : selected_selling_plan2.price_adjustments) == null ? void 0 : _p2[0]) == null ? void 0 : _q2.value)} off` : ((_s2 = (_r2 = selected_selling_plan2 == null ? void 0 : selected_selling_plan2.price_adjustments) == null ? void 0 : _r2[0]) == null ? void 0 : _s2.value_type) === "percentage" ? `Save ${(_u2 = (_t2 = selected_selling_plan2 == null ? void 0 : selected_selling_plan2.price_adjustments) == null ? void 0 : _t2[0]) == null ? void 0 : _u2.value}%` : "" : "";
    state.product = product2;
    state.selected_media_id = (_w2 = (_v2 = product2 == null ? void 0 : product2.media) == null ? void 0 : _v2[0]) == null ? void 0 : _w2.id;
    state.properties = {};
    state.selected_variant = selected_variant2;
    state.selling_plan_allocations = selling_plan_allocations2;
    state.selected_selling_plan = selected_selling_plan2;
    state.selling_plan_discount_wording = selling_plan_discount_wording2;
    state.isAdding = false;
    state.selected_options = selected_variant2 == null ? void 0 : selected_variant2.options;
    state.quantity = 1;
    state.sibling_handle = "";
    state.hydrated = true;
  }, "updateProductState");
  const showConditionally = /* @__PURE__ */ __name((condition) => {
    var _a2, _b2, _c2, _d2;
    switch (condition) {
      case "always": {
        return true;
      }
      case "with_subscriptions": {
        return !!((_b2 = (_a2 = state.selected_variant) == null ? void 0 : _a2.selling_plan_allocations) == null ? void 0 : _b2.length);
      }
      case "no_subscriptions": {
        return !((_d2 = (_c2 = state.selected_variant) == null ? void 0 : _c2.selling_plan_allocations) == null ? void 0 : _d2.length);
      }
    }
  }, "showConditionally");
  const hideIfEmpty = /* @__PURE__ */ __name((element, hide_if_empty, isEmpty = false) => {
    var _a2, _b2;
    switch (hide_if_empty) {
      case "none":
        break;
      case "section":
        (_a2 = element.closest(`.shopify-section`)) == null ? void 0 : _a2.classList.toggle("!hidden", isEmpty);
        break;
      case "container":
        (_b2 = element.closest(`[data-style-id]:not([data-style-id="${element.getAttribute("data-style-id")}"])`)) == null ? void 0 : _b2.classList.toggle("!hidden", isEmpty);
        break;
      case "block":
        break;
    }
  }, "hideIfEmpty");
  return {
    card: state,
    $el,
    $refs,
    handleAddToCart,
    handleBackInStockNotification,
    setSelectedVariant,
    setProductOption,
    setSellingPlan,
    getDynamicText,
    getDynamicValue,
    getContentLabels,
    getDiscountLabel,
    getVariantSwatches,
    getOptionIndex,
    getOptionSwatches,
    truncateChildren,
    hasAvailableVariant,
    updateProductState,
    showConditionally,
    hideIfEmpty
  };
}, "initProductCard");
const hydrateProductCard = /* @__PURE__ */ __name(($el, card_handle, product_handle, product_id, classes = []) => {
  const hydrateProductCardContents = /* @__PURE__ */ __name(() => {
    var _a;
    const node = (_a = document.querySelector(`[data-product-card='${card_handle}']`)) == null ? void 0 : _a.cloneNode(true);
    if (!node && !$el.hasAttribute("data-intersected")) {
      $el.setAttribute("data-intersected", "true");
      const mo = new MutationObserver((mutation, obs) => {
        var _a2;
        if ($el.hasAttribute("data-cards-loaded")) {
          $el.removeAttribute("data-intersected");
          const node2 = (_a2 = document.querySelector(`[data-product-card='${card_handle}']`)) == null ? void 0 : _a2.cloneNode(true);
          if (node2 && $el && $el.parentNode) {
            node2 == null ? void 0 : node2.removeAttribute(`data-product-card`);
            node2 == null ? void 0 : node2.setAttribute("data-product-handle", product_handle);
            node2 == null ? void 0 : node2.setAttribute("data-product-id", product_id);
            node2.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
              el.remove();
            });
            node2.classList.add(...classes);
            $el.parentNode.replaceChild(node2, $el);
          }
          mo.disconnect();
          observer.disconnect();
        }
      });
      mo.observe($el, { attributes: true });
      return;
    }
    if (node && $el && $el.parentNode) {
      node == null ? void 0 : node.removeAttribute(`data-product-card`);
      node == null ? void 0 : node.setAttribute("data-product-handle", product_handle);
      node == null ? void 0 : node.setAttribute("data-product-id", product_id);
      node.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
        el.remove();
      });
      node.classList.add(...classes);
      $el.parentNode.replaceChild(node, $el);
      $el.removeAttribute("data-intersected");
    }
  }, "hydrateProductCardContents");
  if ($el.hasAttribute("data-intersected")) {
    hydrateProductCardContents();
    return;
  }
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        hydrateProductCardContents();
        observer.disconnect();
      }
    },
    { rootMargin: "300px 300px 300px 300px" }
  );
  observer.observe($el);
}, "hydrateProductCard");
window._sections["initProductCard"] = initProductCard;
window._sections["hydrateProductCard"] = hydrateProductCard;
